module.exports = __webpack_public_path__ + "static/media/SkyGradient.087396f9.jpg";